// React for Website

import React from "react";
//outsource
import { Form, Input } from "antd";

//components

const StaffFirstName = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="firstName"
      label="First Name"
      rules={[
        {
          required: true,
          message: "Please input First Name",
        },
        // {
        //   pattern: /^[A-Za-z ]+$/,
        //   message: "Alphabets only",
        // },
        {
          max: 32,
          message: "Max length cannot exceed 32 characters",
        },
      ]}
    >
      <Input placeholder="Please input First Name" disabled={disabled} />
    </Form.Item>
  );
};

export default StaffFirstName;
